import "./PowderTestingAccessories.module.css";
import Header from "@/reusable_sections/Header";
import PowderHero from "./sections/PowderHero";
import ApplicationAreas from "./sections/ApplicationAreas";
import PowderCallout from "./sections/PowderCallout";
import Maintenance from "./sections/Maintenance";
import DiscussCTA from "./sections/DiscussCTA";
import Footer from "@/reusable_sections/Footer";
export default function PowderTestingAccessoriesPage() {
  return <div>
      <Header />
      <PowderHero />
      <ApplicationAreas />
      <PowderCallout />
      <Maintenance />
      <DiscussCTA />
      <Footer />
    </div>;
}